import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Provider } from 'src/app/models/administration/provider';
import { User } from 'src/app/models/administration/user';
import { UserWO } from 'src/app/models/administration/user-WO';
import { Data, DataResouce } from 'src/app/models/commos/base-response-data';
import { CommentDto } from 'src/app/models/maintenance/comment';
import { Resources } from 'src/app/models/maintenance/resources';
import { WorkOrder } from 'src/app/models/maintenance/work-order';
import { CommentService } from 'src/app/services/comment.service';
import { DeleteGenericService } from 'src/app/services/delete-generic.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import {
  FunctionsService,
  HttpService,
  LocalStorageService,
  MessageService,
  TableColumns,
  TableConfiguration,
  enumActions,
  params,
} from 'brainloper-ui';

@Component({
    selector: 'app-generic-notification',
    templateUrl: './generic-notification.component.html',
    styleUrls: ['./generic-notification.component.scss'],
    standalone: false
})
export class GenericNotificationComponent implements OnInit {
  @Input() titleNotification: string = '';
  @Input() note: string = '';
  @Input() showCost: boolean = false;

  @Input() acceptButton: boolean = false;
  @Input() commentButton: boolean = false;
  @Input() declineButton: boolean = false;
  @Input() closeButton: boolean = false;
  @Input() packOffButton: boolean = false;
  @Input() historicalOutputInventory: boolean = false;
  @Input() showMantenanceType: boolean = true;
  @Input() showResponsibles: boolean = true;

  @Output() closeOrder = new EventEmitter<any>();
  @Output() responseAutorization = new EventEmitter<
    [boolean, WorkOrder, User[] | Provider[], Array<Resources>, boolean]
  >();
  @Output() responseStorer = new EventEmitter<
    [WorkOrder, User[] | Provider[], Array<Resources>]
  >();
  @Output() addComment = new EventEmitter<WorkOrder>();

  public EndpointDictionary = EndpointDictionary;
  public userId:number
  public companyId:number

  private urlOrden = `${EndpointDictionary.WorkOrder.CRUD_WORK_ORDER_DATA}`;
  private urlGetUserOrder = `${EndpointDictionary.UserOrder.USER_ORDER_TABLE}`;
  public urlGetTablaResourcesAuthorization: string = `${EndpointDictionary.Resources.RESOURCES_TABLE}`;

  private order;
  private orderId: number;
  public bodyOrder: WorkOrder = {};
  public bodyUser: User[] | Provider[] = [];
  public estado: number = 0;
  public inventoryModule: boolean
  public resources: Array<Resources> = [{ itemName: '' }];
  public viewCarousel: boolean = true;
  public totalCostItems: number;
  private paramsUserOrder: params[] = [
    { id: 'page', value: '0' },
    { id: 'per_page', value: '12' },
    { id: 'filter', value: '' },
    { id: 'orderId', value: '0' },
  ];

  //Tabla Recursos
  public labels = [];
  public reloadResoucesAuthorization = new EventEmitter<any>();
  public paramsResourcesAuthorization: params[] = [
    { id: 'orderId', value: '0' },
  ];
  public configurationResouces: TableConfiguration = {
    edit: false,
    add: false,
    delete: false,
    selectable: false,
    addPer: false,
    editPer: false,
    primaryKey: 'id',
    print: false,
  };
  public columnsResouces: TableColumns<Resources>[]

  //comment table
  public titleC: string = screen.width > 400 ? 'Comentarios OT' : ''
  public paramsComments: params[] = [{ id: 'orderId', value: '0' }];
  public reloadComments = new EventEmitter<any>();
  public pendingReloadComments: boolean = false;
  private _commentsSection: ElementRef;
  private commentsSectionObserver: IntersectionObserver;

  @ViewChild('commentsSection', { read: ElementRef })
  set commentsSection(el: ElementRef) {
    if (el && !this._commentsSection) {
      this._commentsSection = el;
      this.commentsSectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && this.pendingReloadComments) {
            this.pendingReloadComments = false;
            this.reloadComments.emit();
          }
        });
      }, { threshold: 0.1 });
      this.commentsSectionObserver.observe(this._commentsSection.nativeElement);
    }
  }
  public configurationComments: TableConfiguration = {
    edit: true,
    add: true,
    primaryKey: 'id',
    addPer: true,
    editPer: true,
  };

  public columnsComments: TableColumns<CommentDto>[] = [
    {
      ID: 'comment',
      label: 'Comentario',
      type: 'text',
      style: {
        textAlign: 'center',
        width: '70%',
      },
    },
    {
      ID: 'attachmentUrl',
      label: 'Archivo Adjunto',
      type: 'text',
      style: {
        textAlign: 'center',
      },
      rules: [
        {
          action: enumActions.SHOW_FILE_ICON,
        },
      ],
    },
    {
      ID: 'createdBy',
      label: 'Creado por',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
  ];

  constructor(
    private activeRoute: ActivatedRoute,
    private http: HttpService,
    private message: MessageService,
    private functioEter: FunctionsService,
    public notificationService: NotificationsService,
    private storage: LocalStorageService,
    public deleteItem: DeleteGenericService,
    private commentService: CommentService
  ) {
      this.userId = this.storage.get<number>('cedula');
      this.companyId = this.storage.get<number>('companyId');
      this.inventoryModule = this.storage.get<boolean>('inventory_module');

      this.columnsResouces = [
    {
      ID: 'itemName',
      label: 'Nombre',
      type: 'combo',
      disregardForEdit: true,
      style: {
        textAlign: 'center',
      },
      paramsCombo: {
        selectionField: 'id',
        visibleField: 'name',
        urlParams: [
          {
            id: 'id_compania',
            value: `${this.storage.get<number>('id_compania')}`,
          },
        ],
        url: `${EndpointDictionary.Item.ITEM_COMBO}`,
      },
    },
    {
      ID: 'unitMeasurement',
      label: 'Unidad',
      type: 'text',
      disregardForAdd: true,
      disregardForEdit: true,
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'amount',
      label: 'Cantidad',
      type: 'number',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'costItem',
      label: 'Costo Item',
      type: 'thousandSeparator',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'totalCostItems',
      label: 'Costo Total Item',
      type: 'thousandSeparator',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
  ];
  }

  ngOnInit(): void {
    this.validateInventoryModule();
    this.init();
  }

  onAddCommentClick(): void {
    this.pendingReloadComments = true;
    this.addComment.emit(this.bodyOrder);
  }

  validateInventoryModule() {
    if (
      !this.inventoryModule ||
      this.resources.length <= 0 ||
      this.historicalOutputInventory == true
    ) {
      this.viewCarousel = false;
    }
  }

  async init() {
    this.message.openLoading('Cargando', 'Cargando informacion');
    this.activeRoute.queryParamMap.subscribe(async (params) => {
      this.order = { ...params };
      this.orderId =
        this.order.params.id_orden_trabajo ?? this.order.params.id_orden;
      let index = this.paramsUserOrder.findIndex((x) => x.id == 'orderId');
      this.paramsUserOrder[index].value = this.orderId;
      this.paramsComments = [{ id: 'orderId', value: this.orderId }];
      let indexA = this.paramsResourcesAuthorization.findIndex(
        (x) => x.id == 'orderId'
      );
      this.paramsResourcesAuthorization[indexA].value = this.orderId;

      try {
        let res: Array<WorkOrder> = await this.http.getDataBody(
          `${this.urlOrden}/${this.order.params.id_orden_trabajo}`
        );
        let resUserOrder: Data<Array<UserWO>> = await this.http.getDataBody(
          `${this.urlGetUserOrder}`,
          this.paramsUserOrder
        );
        this.bodyOrder = res[0];
        this.bodyOrder.executionDate = this.functioEter.dateIso(
          res[0].executionDate
        );

        if (resUserOrder.data.length > 0) {
          this.bodyUser = resUserOrder.data;
        } else this.bodyUser = [{ name: 'No se tiene asociada información' }];
        this.message.closeLoading();
      } catch (error) {
        this.message.Error('Error', error);
      }
    });
  }

  async dataResources($event: DataResouce<Resources[]>) {
    this.resources = $event.data;
    this.totalCostItems = $event.totalCostItems;
    this.validateInventoryModule();
    this.labels = [
      {
        label: 'Total:',
        value: `$  ${Intl.NumberFormat('es-CO').format(this.totalCostItems)}`,
        edit: false,
      },
    ];
  }

  public dispatchResources() {
    for (const item of this.resources) {
      //item.currentAmount = item.amount
      delete item.id;
    }
    this.responseStorer.emit([this.bodyOrder, this.bodyUser, this.resources]);
  }

  async deleteComments($event: Array<CommentDto>) {
    await this.deleteItem.deleteD(
      $event,
      EndpointDictionary.WorkOrder.COMMENTS.CRUD_DATA,
      'id',
      'Comentario',
      'Comentarios'
    );
    this.reloadComments.emit();
  }

  async addComments($event: number) {
    this.commentService.addComment(this.orderId, () => {
      this.reloadComments.emit();
    });
  }

  async editComments($event: CommentDto) {
    if ($event[0].createdById != this.userId) {
      this.message.Error(
        'Acción no permitida',
        'Solo puedes editar los comentarios que has creado.'
      );
      return;
    }
    await this.commentService.editComment($event[0], () => {
      this.reloadComments.emit();
    });
  }

  onFileIconClick($event: string) {
    this.commentService.showAttachment($event, this.companyId);
  }
}
